<template>
  <div class="condition_query">
    <h1>{{ $t("tool.querytitle") }}</h1>
    <div class="form_com">
      <el-row class="search_com">
        <el-col :span="11">
          <el-input
            placeholder="Please enter the city name/city code/airport name"
            v-model="airportCodes"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" class="query" @click="queryCode">{{ $t("home.book") }}</el-button>
        </el-col>
        <el-col :span="3">
          <p @click="demoCode">{{ $t("tool.exp") }}:&nbsp;BJS</p>
        </el-col>
      </el-row>
      <el-table class="table_com" :data="aiprotData" stripe style="width: 100%">
        <el-table-column
          prop="ApCode"
          label="Airport Code"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="ApName"
          label="Airport Name"
          width="210"
        ></el-table-column>
        <el-table-column prop="CityCode" label="City Code" width="100"></el-table-column>
        <el-table-column prop="CityName" label="City Name" width="140"></el-table-column>
        <el-table-column
          prop="NationCode"
          label="English Name"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="NationName"
          label="Country"
          width="140"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<style type="text/css" scoped="true">
@import "~@/assets/css/view/tool/tool.css";
</style>
<script type="babel">
export default {
    data: function() {
        return {
            airportCode: "",
            NationCode: "",
            NationName: "",
            aiprotData: [
                {
                    ApCode: "—",
                    ApName: "—",
                    NationCode: '-',
                    NationName: '-',
                    CityCode: '-',
                    CityName: '-'
                }
            ],
            demoData: [
                {
                    ApCode: "PEK",
                    ApName: "Capital Airport",
                    NationCode: 'CN',
                    NationName: 'China',
                    CityCode: 'BJS',
                    CityName: 'Beijing'
                },
                {
                    ApCode: "NAY",
                    ApName: "Beijing Nanyuan Airport",
                    NationCode: 'CN',
                    NationName: 'China',
                    CityCode: 'BJS',
                    CityName: 'Beijing'
                },
                {
                    ApCode: "PKX",
                    ApName: "Beijing Daxing International Airport",
                    NationCode: 'CN',
                    NationName: 'China',
                    CityCode: 'BJS',
                    CityName: 'Beijing'
                }
            ]
        };
    },
    computed: {
        airportCodes: {
            get: function() {
                return this.airportCode;
            },
            set: function(val) {
                this.airportCode = val.toUpperCase();
            }
        }
    },
    methods: {
        queryCode: function() {
            var vm = this;
            var re = /^[\u4E00-\u9FA5]+$/;
            var res = /^[a-zA-Z]+$/;
            var sums = /^[\u4E00-\u9FA5a-zA-Z]+$/;
            if (
                sums.test(vm.airportCode) == false ||
                (re.test(vm.airportCode) == true && vm.airportCode.length < 2) ||
                (res.test(vm.airportCode) == true && vm.airportCode.length < 3)
            ) {
                vm.$bus.emit("commmon-notification", null, "Please enter the correct city name");
            } else {
                var data = {
                    x: "weChatQueryByCItyName",
                    y: vm.airportCode,
                    token: ""
                };
                axios
                .post("/WeChatQueryReceiptServletEngineV2", data)
                .then(function(res) {
                    var isData = res.data.ResultData.isData;
                    if (isData == "Y") {
                        var AirPorts = res.data.ResultData.AirPorts;
                        if (AirPorts.length) {
                            vm.aiprotData = AirPorts;
                        } else {
                            var arr = [];
                            arr.push(AirPorts.AirPort);
                            vm.aiprotData = arr;
                        }
                        vm.NationCode = res.data.ResultData.NationCode;
                        vm.NationName = res.data.ResultData.NationName;
                    } else {
                        vm.aiprotData = undefined;
                    }
                });
            }
        },
        demoCode: function() {
            var vm = this;
            vm.aiprotData = vm.demoData;
            vm.NationCode = "CN";
            vm.NationName = "PEK";
        }
    }
};
</script>
